import { render, staticRenderFns } from "./MappModel.vue?vue&type=template&id=402afd18&scoped=true"
import script from "./MappModel.vue?vue&type=script&lang=js"
export * from "./MappModel.vue?vue&type=script&lang=js"
import style0 from "./MappModel.vue?vue&type=style&index=0&id=402afd18&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402afd18",
  null
  
)

export default component.exports